module.exports = __webpack_public_path__ + "static/media/yune_logo_80x80.a59597fc.png";